<template>
  <b-modal
    @show="onShow"
    dialog-class="modal-dialog2"
    contentClass="md-confirm-content"
    :hideHeader="true"
    bodyClass="confirm-body"
    footerClass="confirm-footer"
    :okTitle="$t('common.ok')"
    :cancelTitle="$t('common.cancel1')"
    okVariant="primary md_btn_primary"
    cancelVariant="secondary md_btn_light"
    centered
    :visible="visible"
    @ok="onOk"
    @hidden="onCancel"
  >
    <!--    <p class="dlg_title" style="margin-bottom: 5px;">-->
    <p v-if="site.f_name != '' && site.f_name != undefined" class="dlg_title2" style="margin-bottom: 5px;">
      {{ site.f_name }}
    </p>
    <p class="dlg_title2 h_center" :style="{color: $c.Color.$logo}">[{{ room.f_ho }}]</p>
    <p v-if="address != '' && address != undefined" class="sale_address2">
      <!--    <p class="sale_address">-->
      <b-img :src="require('../../../assets/image/ic_address_detail@2x.png')"
             style="height: 20px; margin-left: 7px; vertical-align: text-bottom;"/>
      {{ address }}
    </p>
    <div class="buttons">
      <b-button
        @click="setReportType('HC')" variant="white"
        :class="['btn btn_wide', this.report_type == 'HC'?'dark_blue':'']"
      >{{ $t('site_report.ho_completion') }}
      </b-button>
      <b-button
        @click="setReportType('HW')" variant="white"
        class="ml-4"
        :class="['btn btn_wide', this.report_type == 'HW'?'dark_blue':'']"
      >{{ $t('site_report.ho_wrong') }}
      </b-button>
    </div>
    <div style="position: relative; width: 90%; margin: 0 auto">
      <b-form-textarea
        v-model="memo"
        rows="5"
        class="textarea_wrap textarea mt-1"
        :placeholder="$t('site_report.report_memo_placeholder')"
        style="height: 98px; margin: 0; width: calc(100% - 50px)"
      />
      <b-button
        class="btn btn_text btn_memo"
        @click="onShowImage"
        style="position: absolute; right: 0px; top: 0px"
      >보기</b-button>
      <b-button
        class="btn btn_text btn_memo dark_blue"
        @click="onAttachImage"
        style="position: absolute; right: 0px; top: 34px"
      >첨부</b-button>
      <input type="file" accept="image/*" @change="onImageChange" style="display: none" ref="img-file">
      <b-button
        class="btn btn_text btn_memo del_btn_color"
        @click="onRemoveImage"
        style="position: absolute; right: 0px; top: 68px"
      >삭제</b-button>
    </div>
    <p class="contentLabel" style="margin-top: 20px;">{{ u.format($t('site_report.report_award'), 100) }}</p>
    <p class="contentLabel1" style="margin-top: 10px;">{{ $t('site_report.report_award_bound') }}</p>
    <!--<p class="contentLabel2">{{$t('site_report.report_award_exception')}}</p>-->
    <p class="contentLabel2">{{ $t('site_report.report_inaccurate_disadvantage') }}</p>
    <Gallery
      :visible.sync="galleryPopupShow"
      :src="memoImages"
      :current="0"
    />
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils";
import Gallery from "../Gallery.vue";

const $u = require('util');
export default {
  name: "HoReportPopup",
  components: {Gallery},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    site: {
      type: Object,
    },
    room: {
      type: Object,
    }
  },
  data() {
    return {
      report_type: 'HC',
      ut: Utils,
      u:$u,
      address: Utils.getAddress(this.site),
      galleryPopupShow: false,
      memo:'',
      memoImages:[],
    }
  },
  methods: {
    setReportType(type) {
      this.report_type = type;
    },
    onShow() {
      this.report_type = 'HC';
    },
    onOk() {
      Utils.showConfirm(this, "<p>" + `[${Utils.getReportTypeText(this.report_type)}] ${this.$t('site_report.ask_report')}` + "</p>" +
        "<p style='color:#cf0000;font-size: 22px;'>" + this.$t('site_report.report_inaccurate_disadvantage') + "</p>").then(
        value => {
          if (value) {
            Utils.requestPost(
              this.$c.API.Site.reportHo,
              {
                site_idx: this.site.f_idx,
                ho_idx: this.room.f_idx,
                report_type: this.report_type,
                complete_status: 'Y', // TODO: 정확한 분양완료상태
                memo: this.memo,
                memo_images: this.memoImages.length > 0 ? this.memoImages.join(',') : '',
              },
            ).then(result => {
              if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                Utils.toast(this, `[${Utils.getReportTypeText(this.report_type)}] ${this.$t('interest.report_confirm_click')}`);
              } else {
                Utils.toast(this, result.code === this.$c.API_RES_CODE.RESULT_ALREADY_EXIST ? this.$t('site_detail.already_reported_today') : result.msg);
              }
            });
          }
        }
      );

      this.$emit('update:visible', false);
    },
    onCancel() {
      this.$emit('update:visible', false);
    },

    onShowImage() {
      if (this.memoImages.length < 1) {
        Utils.toast(this, '첨부된 이미지가 없습니다.');
        return;
      }
      this.galleryPopupShow = true;
    },

    onAttachImage() {
      this.$refs["img-file"].click();
    },

    onRemoveImage() {
      if (this.memoImages.length < 1) {
        Utils.toast(this, '삭제할 이미지가 없습니다.');
        return;
      }
      Utils.showConfirm(this, '마지막 이미지가 삭제됩니다.').then(
        value => {
          if(value){
            this.memoImages.pop();
            Utils.toast(this, '삭제되었습니다.');
          }
        }
      )
    },

    onImageChange(){
      let file = this.$refs['img-file'].files[0];
      Utils.requestUpload(
        this,
        this.$c.API.Upload.image,
        file,
        '2'
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.memoImages.push(result.data.url);
          Utils.toast(this, '첨부되었습니다.');
        } else {
          // Utils.toast(this,result.msg);
          Utils.toast(this, '첨부되지 않았습니다. 다시 시도해주세요.');
        }
      });
    },
  },

}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_vars.scss";

.btn {
  display: flex;
  width: 88px;
  height: 50px;
  border-radius: 3px;
  justify-content: center;
  align-items: center;
  background-color: $c_cacbcd;
  color: $white;
  font-size: $fs_22;
  font-family: $korean_gd_15_r;
  padding: 0;
}

.btn_wide {
  width: 125px;
  margin: 0 20px
}

.buttons {
  margin: 25px auto;
  width: 90%;
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contentLabel {
  font-size: $fs_20;
  color: $c_457fff;
  text-align: center;
  font-family: $korean_gd_14_r;
  text-decoration: underline;
  line-height: 24px;
  margin-bottom: 0;
}

;
.contentLabel1 {
  font-size: $fs_18;
  color: $c_457fff;
  text-align: center;
  font-family: $korean_gd_13_r;
  // line-height: 27;
}

;
.contentLabel2 {
  font-size: $fs_20;
  color: #cf0000;
  text-align: center;
  font-family: $korean_gd_15_r;
  margin-bottom: 0;

}

;


.btn_text {
  padding: 0;
  width: 70px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  background-color: $c_457fff;
  color: $white;
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
  text-align: center;
}

.textarea_wrap {
  margin: 0 8px;
  border: solid 1px #dbd8d8;
  border-radius: 5px;
}

.textarea {
  color: $black;
  font-size: $fs_16;
  font-family: $korean_gd_13_r;
  padding: 12px 9px;
  line-height: 28px;
  margin-bottom: 0;
  white-space: break-spaces;
}

.btn_memo {
  width: 40px;
  height: 30px;
}

.dark_blue {background-color: #0840ba}
.del_btn_color { background-color: #999999!important; }
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/HoReportPopup.vue